import ListItemCardCst from "@components/ListItemCardCst";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { Box } from "@mui/material";
import { ServicesURL } from "@utils/utilsApi";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

const DYNAMIC_GROUPS_URL = ServicesURL.dynamicGroups;

const dateFormatter = new Intl.DateTimeFormat("it-IT", { dateStyle: "short" })
  .format;

export default function DynamicGroupsPanel() {
  const { id: corporateId = "" } = useParams();
  const listUrl = useMemo(() => {
    if (!corporateId) return null;
    return DYNAMIC_GROUPS_URL.replace(":idCorporate", corporateId);
  }, [corporateId]);
  const { dataTable } = useFetchTable(listUrl, undefined, {
    pageIndex: "0",
    pageSize: "6",
    corporateId,
  });
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {dataTable?.output?.map((group: any) => (
        <ListItemCardCst
          title={group.name}
          details={{ row1: `ID: ${group.id}` }}
          badges={[
            {
              label: `Creato il ${dateFormatter(new Date(group.creation_date))}`,
            },
          ]}
        />
      ))}
    </Box>
  );
}
